import { datadogLogs } from '@datadog/browser-logs';
import { ErrorBoundary } from '@strata/react-error-pages';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { App } from 'components/App';
import { AuthProvider } from 'components/auth/AuthProvider';
import { handleError } from 'services/Error';
import { store } from 'store';

import 'main.scss';

datadogLogs.init({
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    service: process.env.REACT_APP_DATADOG_SERVICE,
    env: process.env.REACT_APP_ENV,
    version: process.env.REACT_APP_VERSION,
    forwardErrorsToLogs: true,
});

void (async () => {
    const LDProvider = await asyncWithLDProvider({
        clientSideID: process.env.REACT_APP_LD_CLIENT_ID,
    });

    const root = createRoot(document.getElementById('root')!);
    root.render(
        <StrictMode>
            <ErrorBoundary onError={handleError}>
                <LDProvider>
                    <Provider store={store}>
                        <AuthProvider>
                            <App />
                        </AuthProvider>
                    </Provider>
                </LDProvider>
            </ErrorBoundary>
        </StrictMode>,
    );
})();
